import { jsx as _jsx } from "react/jsx-runtime";
import { PesInitProvider } from "contexts/purhaseExpenseSyncPage/pesInitContext";
import { PesContent } from "layouts/PesContent";
import React from "react";
var providers = [
    function(children) {
        return /*#__PURE__*/ _jsx(PesInitProvider, {
            children: children
        });
    }
];
var PageProvider = function(param) {
    var children = param.children;
    return providers.reduceRight(function(acc, ProviderFn) {
        return ProviderFn(acc);
    }, children);
};
export var PesCreate = function() {
    return /*#__PURE__*/ _jsx(PageProvider, {
        children: /*#__PURE__*/ _jsx(PesContent, {})
    });
};
